import React from 'react'
import Footer from './Footer'
import Header from './Header'
import Main from './Main'

const HomePage: React.FC = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  )
}

export default HomePage
